import { render, staticRenderFns } from "./law-query.vue?vue&type=template&id=2c90c306&scoped=true"
import script from "./law-query.vue?vue&type=script&lang=js"
export * from "./law-query.vue?vue&type=script&lang=js"
import style0 from "./law-query.vue?vue&type=style&index=0&id=2c90c306&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90c306",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c90c306')) {
      api.createRecord('2c90c306', component.options)
    } else {
      api.reload('2c90c306', component.options)
    }
    module.hot.accept("./law-query.vue?vue&type=template&id=2c90c306&scoped=true", function () {
      api.rerender('2c90c306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/law-query.vue"
export default component.exports